(function () {
    'use strict';
    var controllerId = 'migrazioneDati';
    angular.module('app').controller(controllerId, ['$scope', 'common', 'bootstrap.dialog', '$timeout', 'datacontext', '$translate', '$uibModal', '$uibModalInstance', '_', 'vecchioUtente', migrazioneDati]);

    function migrazioneDati($scope, common, bDialog, $timeout, datacontext, $translate, $uibModal, $uibModalInstance, _, vecchioUtente) {

        var getLogFn = common.logger.getLogFn;
        var logError = getLogFn(controllerId, 'logError');

        $scope.vecchioUtente = vecchioUtente;

        $scope.list = {};
        $scope.list.users = [];

        $scope.item = {};
        $scope.item.fEmail = '';
        $scope.item.fUsername = '';
        $scope.item.fStato = 0;
        $scope.item.cerca = getListUsers;

        getListUsers();

        $scope.migrate = function (id) {
            var msg = ' ' + $translate.instant('Utente') + ' ' + $scope.vecchioUtente.Username;
            bDialog.deleteDialog(msg).then(function () {
                datacontext.stak_account_eliminazioneMigrazioneUtente($scope.vecchioUtente.Id, id).then(function (data) {
                    if (data != "204") return logError($translate.instant('ErroreRimozione'));
                    $uibModalInstance.close($scope.vecchioUtente);
                });
            });
        };

        $scope.delete = function () {
            var msg = ' ' + $translate.instant('Utente') + ' ' + $scope.vecchioUtente.Username;
            bDialog.deleteDialog(msg).then(function () {
                datacontext.stak_account_delete($scope.vecchioUtente.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('ErroreRimozione'));
                    $uibModalInstance.close($scope.vecchioUtente);
                });
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function getListUsers() {
            $scope.list.users = [];

            var ruolo = -1;
            if (!$scope.vecchioUtente.bOperatore)
                ruolo = 0;
            else
                ruolo = 1;

            return datacontext.stak_account_getAllByFilter(0, 0, $scope.item.fStato, $scope.item.fUsername, $scope.item.fEmail, ruolo, $scope.vecchioUtente.Id, 'username').then(function (data) {
                if (data) {
                    $scope.list.users = data;
                    return $scope.list.users;
                }   
            });
        }

    }
})();